<div class="loader" *ngIf="authService.loading"></div>

<div class="alert alert-info py-2" *ngIf="mobileNumber&&isEditMobileNo&&(!useralreadyExist||isOtpLogin)">
    <small>OTP sent to <strong>{{mobileNumber}}</strong></small>
    <a href="javascript:void(0)" class="float-end text-decoration-none" (click)="editMobileNumber()">Edit</a>
</div>

<div class="alert alert-info py-2" *ngIf="mobileNumber&&isEditMobileNo&&isMobileAndPassword">
    <small><strong>{{mobileNumber}}</strong></small>
    <a href="javascript:void(0)" class="float-end text-decoration-none" (click)="editMobileNumber()">Edit</a>
</div>

<form autocomplete="off" [formGroup]="loginForm" class="py-2">
    <div #recaptchaContainer>
        <div id="recaptcha-container"></div>
    </div>

    <div class="mb-3" *ngFor="let item of formControls">
        <ng-container [ngSwitch]="item">
            <!-- Mobile Number Field -->
            <ng-container *ngSwitchCase="'mobileNumber'">
                <div class="text-center" *ngIf="!isUserNamePassword">
                    <label class="form-label d-block fw-bold text-uppercase mb-2 text-muted"
                        style="letter-spacing: 0.5px; font-size: 0.8rem;">
                        {{ isAfterSocioLogin ? 'Verify Your Mobile Number' : 'Enter Your Mobile Number' }}
                    </label>
                    <div class="mb-4">
                        <intl-tel-input autocomplete="off" formControlName="mobileNumber"
                            [preferredCountries]="['in', 'us', 'gb']">
                        </intl-tel-input>
                    </div>

                    <button (click)="submit()" class="btn text-white w-100 rounded-pill"
                        style="background-color: #f97316; border: none; font-weight: 600; font-size: 1rem; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);">
                        SEND OTP
                    </button>

                    <div class="invalid-feedback d-block" *ngIf="submitted&&loginForm.get('mobileNumber').errors">
                        Mobile Number is <strong>invalid</strong>
                    </div>
                </div>
            </ng-container>

            <!-- Username Field -->
            <ng-container *ngSwitchCase="'userName'">
                <div class="mb-3">
                    <label class="form-label fw-bold text-uppercase small text-muted">Enter Your Username</label>
                    <input type="text" formControlName="userName" class="form-control" name="username"
                        required="required" [class.is-invalid]="submitted && loginForm.get('userName').invalid">
                    <div class="invalid-feedback" *ngIf="submitted && loginForm.get('userName').invalid">
                        User Name is <strong>required</strong>
                    </div>
                </div>
            </ng-container>

            <!-- Password Field -->
            <ng-container *ngSwitchCase="'password'">
                <div class="mb-3">
                    <label class="form-label fw-bold text-uppercase small text-muted">Password</label>
                    <div class="input-group">
                        <input formControlName="password" [type]="hideOrShowPassword ? 'password' : 'text'"
                            class="form-control" name="password" required="required"
                            [class.is-invalid]="submitted && loginForm.get('password').invalid">
                        <button class="btn btn-outline-secondary" type="button"
                            (click)="hideOrShowPassword = !hideOrShowPassword">
                            <span class="material-icons" style="font-size: 1.2rem;">
                                {{hideOrShowPassword ? 'visibility_off' : 'visibility'}}
                            </span>
                        </button>
                    </div>
                    <div class="invalid-feedback d-block" *ngIf="submitted && loginForm.get('password').invalid">
                        <div class="d-flex justify-content-between">
                            <div>Password is <strong>invalid</strong></div>
                        </div>
                    </div>
                    <div class="text-end mt-1" *ngIf="isUserNamePassword">
                        <a href="javascript:void(0);" class="text-decoration-none small text-muted">Forgot Password?</a>
                    </div>
                </div>
            </ng-container>

            <!-- Name Field -->
            <ng-container *ngSwitchCase="'name'">
                <div class="mb-3">
                    <label class="form-label fw-bold text-uppercase small text-muted">Enter Your Name</label>
                    <input type="text" formControlName="name" class="form-control" name="name" required="required"
                        [class.is-invalid]="submitted && loginForm.get('name').invalid">
                    <div class="invalid-feedback" *ngIf="submitted && loginForm.get('name').invalid">
                        Name is <strong>required</strong>
                    </div>
                </div>
            </ng-container>

            <!-- OTP Field -->
            <ng-container *ngSwitchCase="'otp'">
                <div class="mb-3">
                    <label class="form-label fw-bold text-uppercase small text-muted">Enter Otp</label>
                    <input type="text" formControlName="otp" class="form-control" name="otp" required="required"
                        [class.is-invalid]="submitted && loginForm.get('otp')?.errors">

                    <div class="invalid-feedback" *ngIf="submitted && loginForm.get('otp')?.errors?.invalidOTP">
                        OTP is <strong>invalid</strong>
                    </div>
                    <div class="invalid-feedback" *ngIf="submitted && loginForm.get('otp')?.errors?.required">
                        OTP is <strong>required</strong>
                    </div>

                    <div class="d-flex justify-content-between align-items-center mt-2 notranslate">
                        <small class="text-muted"
                            *ngIf="!countFinished&&!authService?.loading&&!loginForm.get('otp')?.errors?.invalidOTP">
                            Resend in:
                            <span [counter]="90" [interval]="1000" (value)="counterValue = $event"
                                (countFinished)="countFinished = $event" class="fw-bold">
                                00:{{counterValue<10?('0'+counterValue):counterValue}} </span>
                        </small>

                        <small class="text-primary fw-bold" style="cursor: pointer;" (click)="resendOtp()"
                            *ngIf="(!authService?.loading&&countFinished)||loginForm.get('otp')?.errors?.invalidOTP">
                            Resend OTP
                        </small>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>

    <!-- Main Action Button (Submit) -->
    <div class="mb-4" *ngIf="isUserNamePassword || isEditMobileNo">
        <button (click)="submit()" class="btn text-white w-100 rounded-pill"
            style="background-color: #f97316; border: none; font-weight: 600; font-size: 1rem; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);">
            {{ isUserNamePassword ? 'LOGIN' : 'VERIFY & LOGIN' }}
        </button>
    </div>

    <!-- Separator -->
    <div class="sociologin text-center mt-2 mb-4" *ngIf="!isEditMobileNo && !isAfterSocioLogin">
        <div class="d-flex align-items-center justify-content-center my-3">
            <hr class="flex-grow-1 border-top" style="opacity: 0.2;">
            <span class="mx-2 text-muted small" style="font-weight: 300;">- or -</span>
            <hr class="flex-grow-1 border-top" style="opacity: 0.2;">
        </div>
    </div>

    <div *ngIf="!isAfterSocioLogin"
        class="d-flex flex-column flex-sm-row justify-content-center align-items-stretch align-items-sm-center gap-2 gap-sm-3 mt-1">
        <button (click)="signInAnonymously()" class="btn btn-guest flex-grow-1 px-3">
            CONTINUE AS GUEST
        </button>
        <button (click)="onSocialLogin('GOOGLE')" class="btn login-with-google-btn flex-grow-1">
            GOOGLE LOGIN
        </button>
    </div>

    <!-- Footer Agreement -->
    <div class="text-center mt-5" *ngIf="!isEditMobileNo && !isAfterSocioLogin">
        <p class="text-muted mb-0" style="font-size: 0.75rem;">
            By logging in, you agree to our
            <a href="javascript:void(0)" class="text-orange text-decoration-none fw-bold"
                (click)="openTerms.emit()">Terms and Conditions</a>
            and
            <a href="javascript:void(0)" class="text-orange text-decoration-none fw-bold"
                (click)="openPrivacy.emit()">Privacy Policy</a>
        </p>
    </div>
</form>